module.exports = "/_next/static/images/officeimage-de19b69c7de986889bd5dbeb74474a1e.png";